import { createRouter, createWebHistory } from "vue-router";
import { useDataStore } from "../stores/data";
import Landing from "@/www/pages/burse/landing/index.vue";

const baseUrl = "https://useburse.com";

// SEO meta tags configuration for each route
const seoMeta = {
  "/": {
    title: "Build Wealth in Naira. Save and Invest Online!",
    description: "With Burse, grow your money, earn up to 25% annually on savings and investment plans in Nigeria",
    canonical: `${baseUrl}/`,
  },
  "/burseLanding": {
    title: "Burse - Empowering Workers to Build Wealth | Burse",
    description: "Burse empowers every worker to build wealth with secure investing and smart saving plans in Nigeria.",
    canonical: `${baseUrl}/burseLanding`,
  },
  "/impact-fund": {
    title: "Impact Fund - Socially Responsible Investing | Burse",
    description: "Invest in our Impact Fund and make a difference while earning returns. Socially responsible investing with Burse.",
    canonical: `${baseUrl}/impact-fund`,
  },
  "/waitlist": {
    title: "Join the Waitlist | Burse",
    description: "Save smarter, invest confidently, and enjoy life. Join the Burse waitlist to get early access.",
    canonical: `${baseUrl}/waitlist`,
  },
  "/burse/bursevault": {
    title: "Save and Invest Online with Burse Vault",
    description: "Earn up to 25% compound interest on savings and investments in Nigeria with Burse Vault on Burse",
    canonical: `${baseUrl}/burse/bursevault`,
  },
  "/burse/burseflex": {
    title: "Save and Invest Naira Online with Burse Flex",
    description: "Enjoy flexible savings and investment plans in Nigeria with Burse Flex on Burse",
    canonical: `${baseUrl}/burse/burseflex`,
  },
  "/burse/targetsavings": {
    title: "Save and Invest Online with Target Savings",
    description: "Earn high-yield interest on savings and investment in Nigeria with Target Savings on Burse",
    canonical: `${baseUrl}/burse/targetsavings`,
  },
  // Burse Collective disabled — see routes below
  // "/burse/bursecollective": {
  //   title: "Burse Collective | Burse",
  //   description: "Invest in low-risk money market instruments with Burse Collective on Burse.",
  //   canonical: `${baseUrl}/burse/bursecollective`,
  // },
  "/burse/buildwealth": {
    title: "Build Wealth | Burse",
    description: "Project your future wealth over 10, 20, and 30 years with Build Wealth on Burse.",
    canonical: `${baseUrl}/burse/buildwealth`,
  },
  "/burse/save": {
    title: "Start Saving Today - Build Your Wealth | Burse",
    description: "Start your savings journey with Burse. Choose from flexible savings, target savings, or fixed deposits.",
    canonical: `${baseUrl}/burse/save`,
  },
  "/burse/calculator": {
    title: "Savings & Investment Calculator | Burse",
    description: "Calculate your potential returns with our savings and investment calculator. Plan your financial future.",
    canonical: `${baseUrl}/burse/calculator`,
  },
  "/burse/privacy-policy": {
    title: "Privacy Policy | Burse",
    description: "Read Burse's privacy policy to understand how we collect, use, and protect your personal information.",
    canonical: `${baseUrl}/burse/privacy-policy`,
  },
  "/burse/terms-of-use": {
    title: "Terms of Use | Burse",
    description: "Review Burse's terms of use and service agreement. Understand your rights and responsibilities.",
    canonical: `${baseUrl}/burse/terms-of-use`,
  },
};

// website pages

const routes = [
  /*---- website routes  ----*/
  {
    path: "/",
    name: "Landing",
    component: Landing,
    children: [
      {
        path: "",
        name: "LandingView",
        component: () => import("@/www/pages/burse/landing/LandingView.vue"),
      },
    ],
  },
  {
    path: "/financial-quiz",
    name: "FinancialView",
    component: () => import("@/www/pages/burse/fin-quiz/FinancialView.vue"),
    children: [
      {
        path: "",
        name: "FinancialWelcome",
        component: () =>
          import("@/www/pages/burse/components/fin-quiz/FinancialWelcome.vue"),
      },
      {
        path: "/financial-quiz-test",
        name: "FinancialQuizTest",
        component: () => import("@/www/pages/burse/fin-quiz/FinancialQuiz.vue"),
      },
      {
        path: "/financial-quiz-result",
        name: "FinancialQuizResult",
        component: () => import("@/www/pages/burse/fin-quiz/FinancialResult.vue"),
        beforeEnter: (to, from, next) => {
          const isAllowed = JSON.parse(localStorage.getItem("user-data"));
          // console.log(isAllowed)
          if (isAllowed?.isFinQuizCompleted) {
            next();
          } else {
            next("/financial-quiz-test");
          }
        },
      },
    ],
  },
  {
    path: "/download-app",
    name: "AppClick",
    component: () => import("@/www/pages/AppClick.vue"),
  },
  {
    path: "/burseLanding",
    name: "WnpLanding",
    component: () => import("@/www/pages/burse/landing/index.vue"),
  },
  {
    path: "/individual",
    name: "Individual",
    component: () => import("@/www/pages/individual/index.vue"),
  },
  // {
  //   path: "/business",
  //   name: "Business",
  //   component: () => import("@/www/pages/business/index.vue"),
  // },
  {
    path: "/manage-employee",
    name: "DeviceManagement",
    component: () => import("@/www/pages/mgt/index.vue"),
  },
  // {
  //   path: "/assess-employee",
  //   name: "AssessEmployee",
  //   component: () => import("@/www/pages/assessment/index.vue"),
  // },
  // {
  //   path: "/hr-stores",
  //   name: "HrStores",
  //   component: () => import("@/www/pages/hrstores/index.vue"),
  // },
  {
    path: "/paye",
    name: "PayePage",
    component: () => import("@/www/pages/paye/index.vue"),
  },
  // {
  //   path: "/developers",
  //   name: "Developers",
  //   component: () => import("@/www/pages/developers/index.vue"),
  // },
  {
    path: "/about-us",
    name: "AboutUs",
    component: () => import("@/www/pages/about/index.vue"),
  },
  // {
  //   path: "/learn-more",
  //   name: "LearnMore",
  //   component: () => import("@/www/pages/learn-more/index.vue"),
  // },
  {
    path: "/impact-fund",
    name: "ImpactFund",
    component: () => import("@/www/pages/burse/ImpactFund.vue"),
  },
  {
    path: "/waitlist",
    name: "Waitlist",
    component: () => import("@/www/pages/waitlist/index.vue"),
  },
  {
    path: "/burse/bursevault",
    name: "BurseVault",
    component: () => import("@/www/pages/burse/BurseVault.vue"),
  },

  {
    path: "/burse/burseflex",
    name: "BurseFlex",
    component: () => import("@/www/pages/burse/BurseFlex.vue"),
  },
  {
    path: "/burse/targetsavings",
    name: "TargetSavings",
    component: () => import("@/www/pages/burse/TargetSavings.vue"),
  },
  // Burse Collective disabled — page kept in codebase, route intentionally removed
  // so /burse/bursecollective falls through to the catch-all redirect below.
  // {
  //   path: "/burse/bursecollective",
  //   name: "BurseCollective",
  //   component: () => import("@/www/pages/burse/BurseCollective.vue"),
  // },
  {
    path: "/burse/buildwealth",
    name: "BuildWealth",
    component: () => import("@/www/pages/burse/BuildWealth.vue"),
  },
  {
    path: "/build-wealth/gift/:token/amount",
    name: "BuildWealthGiftAmount",
    component: () => import("@/www/pages/burse/BuildWealthGiftAmount.vue"),
  },
  {
    path: "/build-wealth/gift/:token/success",
    name: "BuildWealthGiftSuccess",
    component: () => import("@/www/pages/burse/BuildWealthGiftSuccess.vue"),
  },
  {
    path: "/build-wealth/gift/:token",
    name: "BuildWealthGift",
    component: () => import("@/www/pages/burse/BuildWealthGift.vue"),
  },
  {
    path: "/build-wealth/gift/success",
    name: "BuildWealthGiftCallback",
    component: () => import("@/www/pages/burse/BuildWealthGiftSuccess.vue"),
  },
  {
    path: "/burse/save",
    name: "SavePage",
    component: () => import("@/www/pages/burse/SavePage.vue"),
  },
  {
    path: "/burse/calculator",
    name: "CalculatorPage",
    component: () => import("@/www/pages/burse/CalculatorPage.vue"),
  },

  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("@/www/pages/privacy-policy.vue"),
  },
  {
    path: "/burse/privacy-policy",
    name: "WNPPrivacyPolicy",
    component: () => import("@/www/pages/burse/privacy-policy.vue"),
  },

  {
    path: "/terms-of-use",
    name: "TermsOfUse",
    component: () => import("@/www/pages/terms-of-use.vue"),
  },
  {
    path: "/burse/terms-of-use",
    name: "WNPTermsOfUse",
    component: () => import("@/www/pages/burse/terms-of-use.vue"),
  },

  /*--- website routes end -----*/

  {
    path: "/app/:pathMatch(.*)*",
    name: "OpenInApp",
    component: () => import("@/www/pages/burse/OpenInApp.vue"),
  },

  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    // Handle hash navigation
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
        top: 100, // Offset for fixed header
      };
    }

    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  // ✅ This will work because the router starts its navigation after
  // the router is installed and pinia will be installed too
  const store = useDataStore();
  if (to.query && to.query.fromMobile && to.query.token) {
    window.localStorage.setItem("token", to.query.token);
    window.localStorage.setItem("refreshToken", to.query.refreshToken);
    store.$patch({
      // userPrivileges: res.privileges,
      isLoggedIn: true,
      fromApp: true,
    });
    // next("/loan/application/view");
  }
  if (to.meta.requiresAuth && !store.isLoggedIn) {
    next("/login");
  } else {
    // Set meta tags early, before navigation completes (for pre-rendering)
    // const meta = seoMeta[to.path];
    // if (meta) {
    //   // Set meta tags immediately so pre-renderer captures them
    //   if (typeof document !== 'undefined') {
    //     document.title = meta.title;
        
    //     let metaDesc = document.querySelector('meta[name="description"]');
    //     if (!metaDesc) {
    //       metaDesc = document.createElement('meta');
    //       metaDesc.setAttribute('name', 'description');
    //       document.head.appendChild(metaDesc);
    //     }
    //     metaDesc.setAttribute('content', meta.description);
        
    //     let canonical = document.querySelector('link[rel="canonical"]');
    //     if (!canonical) {
    //       canonical = document.createElement('link');
    //       canonical.setAttribute('rel', 'canonical');
    //       document.head.appendChild(canonical);
    //     }
    //     canonical.setAttribute('href', meta.canonical);
    //   }
    // }
    next();
  }
});

// Set SEO meta tags after navigation (runs immediately for pre-rendering)
router.afterEach((to) => {
  const meta = seoMeta[to.path];
  if (meta) {
    // Use nextTick to ensure DOM is ready, but set immediately for pre-rendering
    // Update document head directly for better SEO
    document.title = meta.title;
    
    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', meta.description);
    
    // Ensure robots meta tag allows indexing
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'index, follow');
    
    // Update or create canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', meta.canonical);
    
    // Update or create Open Graph tags
    const ogTags = {
      'og:title': meta.title,
      'og:description': meta.description,
      'og:url': meta.canonical,
      'og:type': 'website',
    };
    
    Object.entries(ogTags).forEach(([property, content]) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', content);
    });
    
    // Update or create Twitter tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': meta.title,
      'twitter:description': meta.description,
    };
    
    Object.entries(twitterTags).forEach(([name, content]) => {
      let twitterTag = document.querySelector(`meta[name="${name}"]`);
      if (!twitterTag) {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('name', name);
        document.head.appendChild(twitterTag);
      }
      twitterTag.setAttribute('content', content);
    });
  }
});

export default router;
